import React from 'react';
import Radium from 'radium';


class Input extends React.Component {



    render() {

        const rowBlockLeft = {
            textAlign: 'left',
            paddingBottom: '2px',
            boxSizing: 'border-box',
            overflow: 'auto',

            // For mobile
            '@media (max-width: 992px)': {
                display: 'block',
                height: '20px',
                lineHeight: '20px'

            },

            '@media print': {
                width: '20%',
                display: 'inline',
                fontSize: '10px',
            }
        }

        const rowInputLeft = {
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none',
            overflow: 'auto',
            fontSize: '15px',
            border: '1px solid grey',
            paddingLeft: '8px',
            textAlign: 'left',
            float: 'right',
            borderRadius: '0px',
            padding: '9px',
            backgroundColor: 'transparent',
            boxSizing: 'border-box',
            width: '100%',
            // For mobile
            '@media (max-width: 992px)': {
                width: '100%',
                boxSizing: 'border-box',
            },

            '@media print': {
                width: '40%',
                display: 'inline',
                boxSizing: 'content-box',
                fontSize: '10px',

            }
        }

        const customerInfoRow = {
            marginTop: '10px',
            overflow: 'auto',
            display: 'block'
        }

        return (
            <div>
                <div style={customerInfoRow}>

                    <select onChange={(event) => {
                        console.log(event.target.value); // 1234.5
                        console.log(this.props.fieldname); // 1234.5
                        let valuetosend = [event.target.value, this.props.fieldname]
                        this.props.getValue(valuetosend)
                    }}
                        style={rowInputLeft}>
                        <option value="Small van">Car or small van</option>
                        <option value="Large van">Large van</option>
                        <option value="Extra large">Extra large van</option>
                    </select>
<div style={{marginTop:'5px',fontSize:'12px'}}><a href="https://pjtsamedaycouriers.co.uk/vehicles">For vehicle help click here</a></div>


                </div>
            </div>
        );
    }
}

Input = Radium(Input);
export default Input;